import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import columns from './columns';

const namespaced = true;

const state = {
  classes: [],
  columns,
  count: 0,
  currentPage: 0,
  dateRange: null,
  filters: {},
  lastRefreshDate: null,
  missingFeedbackClassesCount: 0,
  nearestClasses: [],
  ordering: 'scheduled_at',
  pageSize: 15,
};

export default {
  namespaced,
  actions,
  getters,
  mutations,
  state,
};
